import styled from 'styled-components';

export const StartButton = styled.img`
    cursor: pointer;
`;

export const VolumeButton = styled.div`
    cursor: pointer;
    font-size: 40px;
    float: right;
    padding-top: 10px;
    padding-right: 10px;
    z-index: 1;
    position: relative;
`;

export const Header = styled.div`
    font-family: digital-clock-font;
    font-size: 15vw;
    margin-bottom: 100px;
    text-shadow: 4px 4px 3px #777;
`;

export const MenuWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    flex-direction: column;
`;

export const Ground = styled.div`
    position: fixed;
    width: 100%;
    height: 20%;
    background: #8e3b26;
    left: 0;
    bottom: 0;
    z-index: -10;
`;

export const ScoreText = styled.div`
    padding: 10px;
    font-size: 34px;
    font-weight: bold;
`;
